import React from 'react'
import {Grid, Row, Col} from 'react-flexbox-grid'
import {Link} from 'react-router'
import {FormattedRelative} from 'react-intl'
import _ from 'lodash'

import {Breadcrumb, Icon, Menu} from 'antd'

import {Query} from '../query'
import {NotFound} from 'pages/NotFound'
import {NetworkService} from 'api/network'

import {Overview} from './overview'
import {DeviceManagement} from './device-manager'
import {ACL} from './acl'
import {SetupGuide} from '../setup-guide'

// this does NOT work with index routes
const buildPath = (parent, dest, {routes, params}) => {
   let parentRoutes = _.dropRightWhile(routes, ({component}) => !_.eq(parent, component)),
      path = _.map(parentRoutes, comp => comp.path).concat([dest]).join('/').replace(/\/\//, '/')

   return _.reduce(params, (acc, newVal, val) => acc.replace(':' + val, newVal), path)
}

const NetworkMeta = ({network}) => {
   if (!network) {
      return null
   }

   return (
      <div className="text-right metabar">
         {network.meta.updated &&
            <span>
               Updated: <FormattedRelative value={network.meta.updated} />
            </span>}
         {network.meta.created && network.meta.updated && ' — '}
         {network.meta.created &&
            <span>
               Created: <FormattedRelative value={network.meta.created} />
            </span>}
      </div>
   )
}

NetworkMeta.propTypes = {
   network: React.PropTypes.object.isRequired
}

export class Network extends React.Component {
   static get propTypes() {
      return {
         params:   React.PropTypes.object.isRequired,
         network:  React.PropTypes.object.isRequired,
         children: React.PropTypes.node.isRequired,
         router:   React.PropTypes.object.isRequired,
         Sidebar:  React.PropTypes.func
      }
   }

   static get defaultProps() {
      return {
         network: {meta: {}}
      }
   }

   componentWillMount() {
      let {params} = this.props

      this._mounted = true

      NetworkService.fetch(params.nid)

      this.handleClick = this.handleClick.bind(this)
   }

   componentWillReceiveProps(nextProps) {
      if (this.props.params.nid !== nextProps.params.nid) {
         NetworkService.fetch(nextProps.params.nid)
      }
   }

   componentWillUnmount() {
      this._mounted = false
   }

   static get sidebar() {
      return true
   }

   handleClick(ev) {
      const nextPath = ev.key.match(/^\//) ? ev.key : buildPath(Network, ev.key, this.props)

      this.props.router.push(nextPath)
   }

   render() {
      const {network, children, Sidebar, ...props} = this.props
      const [route, selected] = _.dropWhile(
         props.routes,
         ({path}) => path !== props.route.path
      ).slice(1)
      let subpath = (selected || {}).path

      return (
         <div className="network">
            <Network.TopNav
               network={network}
               onClick={this.handleClick}
               pathname={subpath}
               route={route}
               routes={props.routes}
               params={props.params}
            />

            <Grid>
               <Row>
                  {!network &&
                     Sidebar &&
                     <Col xs={4}>
                        <Sidebar />
                     </Col>}
                  <Col xs={!network && Sidebar ? 8 : 12}>
                     {!network ? <NotFound /> : React.cloneElement(children, {network, ...props})}
                  </Col>
               </Row>
            </Grid>
         </div>
      )
   }
}

Network.buildPath = buildPath

Network.TopNav = ({network, pathname, routes, params, route, children}) => {
   return (
      <div className="nav net-nav">
         <Grid>
            <Row>
               <Col xs={12}>
                  <Menu mode="horizontal" selectedKeys={[pathname]}>
                     {children && children}

                     {_.map(route.childRoutes, (child, _idx) => {
                        return !child.name || (undefined !== child.show && child.show(network))
                           ? null
                           : <Menu.Item key={child.path}>
                                <Link
                                   to={
                                      child.path.match(/^\//)
                                         ? child.path
                                         : buildPath(Network, child.path, {routes, params})
                                   }
                                >
                                   {child.glyph &&
                                      <Icon type={child.glyph} style={{marginRight: '1.5rem'}} />}
                                   {child.name}
                                </Link>
                             </Menu.Item>
                     })}

                  </Menu>

                  <ol className="metabar">
                     {network.meta.updated &&
                        <li key="updated" style={{float: 'right', marginLeft: '1rem'}}>
                           <small>
                              Updated: <FormattedRelative value={network.meta.updated} />
                           </small>
                        </li>}
                     {network.meta.created &&
                        <li key="created" style={{float: 'right', marginLeft: '1rem'}}>
                           <small>
                              Created: <FormattedRelative value={network.meta.created} />
                           </small>
                        </li>}
                  </ol>

               </Col>
            </Row>
            <Row>
               <Col>
                  <Breadcrumb>
                     <Breadcrumb.Item>
                        <Link to="/dashboard">
                           <Icon type="left" style={{marginRight: '1.5rem'}} />
                           All Networks
                        </Link>
                     </Breadcrumb.Item>
                     <Breadcrumb.Item>
                        <Link to={`/dashboard/network/${network.key}/overview`}>
                           Network: {network.name || 'Unnamed Network'}
                        </Link>
                     </Breadcrumb.Item>
                  </Breadcrumb>
               </Col>
            </Row>
         </Grid>
      </div>
   )
}

Network.TopNav.propTypes = {
   network:  React.PropTypes.object.isRequired,
   pathname: React.PropTypes.string.isRequired,
   route:    React.PropTypes.object.isRequired,
   onClick:  React.PropTypes.func.isRequired,
   children: React.PropTypes.element
}

Network.onEnter = (nextState, replace) => {
   if (_.last(nextState.routes).component === Network) {
      replace({pathname: buildPath(Network, 'overview', nextState)})
   }
}

Network.childRoutes = [
   {
      name:        'Overview',
      glyph:       'home',
      path:        'overview',
      component:   Overview,
      childRoutes: Overview.childRoutes
   },
   {
      name:        'Device Management',
      glyph:       'bars',
      path:        'devices',
      component:   DeviceManagement,
      childRoutes: DeviceManagement.childRoutes
   },
   {
      name:        'Query',
      glyph:       'search',
      path:        'query',
      component:   Query,
      childRoutes: Query.childRoutes
   },
   {
      name:        'Permissions',
      glyph:       'lock',
      path:        'acl',
      component:   ACL,
      childRoutes: ACL.childRoutes
   },
   {
      name:      'Setup Guide',
      glyph:     'bulb',
      path:      'setup',
      component: props => <SetupGuide embedded={true} {...props} />,
      show:      () => !SetupGuide.setupFinished
   },
   {
      path:      '*',
      component: NotFound
   }
]



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/index.js